<template>
  <div class="delivery-bill-container">
    <p
      dir="ltr"
      style="line-height: 1.2; margin-top: 0.35pt; margin-bottom: 0pt"
    >
      <img :src="appLogo" style="width: 222px" />
    </p>
    <p><br /></p>
    <p
      dir="ltr"
      style="
        line-height: 1.2;
        margin-left: 5.65pt;
        margin-top: 5pt;
        margin-bottom: 0pt;
      "
    >
      <span
        style="
          font-size: 16pt;
          font-family: 'Noto Sans', sans-serif;
          color: #000000;
          background-color: transparent;
          font-weight: 700;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre;
          white-space: pre-wrap;
        "
        >BON DE LIVRAISON</span
      ><span style="margin-left: 250px"
        >Frais de livraison: &nbsp;&nbsp;&nbsp;&nbsp; DT</span
      >
    </p>
    <p
      dir="ltr"
      style="
        line-height: 1.2;
        margin-left: 6.4pt;
        margin-top: 5pt;
        margin-bottom: 0pt;
      "
    >
      <span
        style="
          font-size: 9pt;
          font-family: 'Noto Sans', sans-serif;
          color: #000000;
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre;
          white-space: pre-wrap;
        "
      >
        &nbsp;:&nbsp;</span
      ><span
        style="
          font-size: 9pt;
          font-family: 'Noto Sans', sans-serif;
          color: #000000;
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre;
          white-space: pre-wrap;
        "
        >&nbsp;</span
      >
    </p>
    <div align="left" dir="ltr" style="margin-left: 0pt">
      <table
        style="
          border: none;
          border-collapse: collapse;
          table-layout: fixed;
          width: 493.27559055118115pt;
        "
      >
        <tbody>
          <tr style="height: 0pt">
            <td
              style="
                border-left: solid #000000 1pt;
                border-right: solid #000000 1pt;
                border-bottom: solid #000000 1pt;
                border-top: solid #000000 1pt;
                vertical-align: top;
                padding: 5pt 5pt 5pt 5pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <p
                dir="ltr"
                style="
                  line-height: 1.2;
                  text-align: center;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: 'Noto Sans', sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Article&nbsp;</span
                >
              </p>
            </td>
            <td
              style="
                border-left: solid #000000 1pt;
                border-right: solid #000000 1pt;
                border-bottom: solid #000000 1pt;
                border-top: solid #000000 1pt;
                vertical-align: top;
                padding: 5pt 5pt 5pt 5pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <p
                dir="ltr"
                style="
                  line-height: 1.2;
                  text-align: center;
                  margin-top: 0pt;
                  margin-bottom: 0pt;
                "
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: 'Noto Sans', sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Prix&nbsp;</span
                >
              </p>
            </td>
          </tr>
          <tr
            style="height: 0pt"
            v-for="(item, index) in products"
            :key="index"
          >
            <td
              style="
                border-left: solid #000000 1pt;
                border-right: solid #000000 1pt;
                border-bottom: solid #000000 1pt;
                border-top: solid #000000 1pt;
                vertical-align: top;
                padding: 5pt 5pt 5pt 5pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <p
                dir="ltr"
                style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: 'Noto Sans', sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >{{ item.name }}&nbsp;</span
                >
              </p>
            </td>
            <td
              style="
                border-left: solid #000000 1pt;
                border-right: solid #000000 1pt;
                border-bottom: solid #000000 1pt;
                border-top: solid #000000 1pt;
                vertical-align: top;
                padding: 5pt 5pt 5pt 5pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <p
                dir="ltr"
                style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: 'Noto Sans', sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >{{ item.price }}</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 0pt">
            <td
              style="
                border-left: solid #000000 1pt;
                border-right: solid #000000 1pt;
                border-bottom: solid #000000 1pt;
                border-top: solid #000000 1pt;
                vertical-align: top;
                padding: 5pt 5pt 5pt 5pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <p
                dir="ltr"
                style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: 'Noto Sans', sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >Total</span
                >
              </p>
            </td>
            <td
              style="
                border-left: solid #000000 1pt;
                border-right: solid #000000 1pt;
                border-bottom: solid #000000 1pt;
                border-top: solid #000000 1pt;
                vertical-align: top;
                padding: 5pt 5pt 5pt 5pt;
                overflow: hidden;
                overflow-wrap: break-word;
              "
            >
              <p
                dir="ltr"
                style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt"
              >
                <span
                  style="
                    font-size: 10pt;
                    font-family: 'Noto Sans', sans-serif;
                    color: #000000;
                    background-color: transparent;
                    font-weight: 400;
                    font-style: normal;
                    font-variant: normal;
                    text-decoration: none;
                    vertical-align: baseline;
                    white-space: pre;
                    white-space: pre-wrap;
                  "
                  >&nbsp;</span
                >
                <!-- {{
                    products
                      .reduce((acc, it) => (acc += it.price), 0)
                      .toFixed(2)
                  }} DT -->
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p
      dir="ltr"
      style="
        line-height: 1.2;
        margin-left: 9.05pt;
        margin-top: 8.35pt;
        margin-bottom: 0pt;
      "
    >
      <span
        style="
          font-size: 9pt;
          font-family: 'Noto Sans', sans-serif;
          color: #000000;
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre;
          white-space: pre-wrap;
        "
        >&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span
      >
    </p>
    <p dir="ltr" style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt">
      <span
        style="
          font-size: 10pt;
          font-family: 'Noto Sans', sans-serif;
          color: #000000;
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre;
          white-space: pre-wrap;
        "
        >&nbsp;</span
      >
    </p>
    <p><br /></p>
    <p dir="ltr" style="line-height: 1.2; margin-top: 0pt; margin-bottom: 0pt">
      <br />
    </p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p><br /></p>
    <p
      dir="ltr"
      style="
        line-height: 1.2;
        margin-left: 94.85pt;
        margin-right: 94.85pt;
        text-align: center;
        margin-top: 5.35pt;
        margin-bottom: 0pt;
      "
    >
      <span
        style="
          font-size: 9pt;
          font-family: 'Noto Sans', sans-serif;
          color: #000000;
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre;
          white-space: pre-wrap;
        "
        >**Merci d&rsquo;avoir choisi {{ applicationName }} **</span
      >
    </p>
    <p
      dir="ltr"
      style="
        line-height: 1.2;
        margin-left: 94.85pt;
        margin-right: 94.85pt;
        text-align: center;
        margin-top: 5.35pt;
        margin-bottom: 0pt;
      "
    ></p>
    <p
      dir="ltr"
      style="
        line-height: 1.2;
        margin-left: 94.85pt;
        margin-right: 94.85pt;
        text-align: center;
        margin-top: 1.25pt;
        margin-bottom: 0pt;
      "
    >
      <span
        style="
          font-size: 9pt;
          font-family: 'Noto Sans', sans-serif;
          color: #000000;
          background-color: transparent;
          font-weight: 400;
          font-style: normal;
          font-variant: normal;
          text-decoration: none;
          vertical-align: baseline;
          white-space: pre;
          white-space: pre-wrap;
        "
        >{{ appContact }}</span
      >
    </p>
    <p><br /></p>
    <p><br /></p>
  </div>
</template>
<script>
import { Printd } from "printd";
import constants from "@/mixins/constants";
export default {
  mixins: [constants],
  props: {
    client: {
      type: Object,
      default: () => {
        return {};
      },
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    date: function () {
      const date = new Date();
      const month = date.getMonth() + 1;
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      return (
        (dayOfMonth < 10 ? "0" + dayOfMonth : dayOfMonth) +
        "/" +
        (month < 10 ? "0" + month : month) +
        "/" +
        year
      );
    },
    printMe() {
      const d = new Printd();
      d.print(this.$el, [
        `
        table {
    border:solid #000 !important;
    border-width:1px 0 0 1px !important;
}
th, td {
    border:solid #000 !important;
    border-width:0 1px 1px 0 !important;
}
      `,
      ]);
    },
  },
};
</script>
<style lang="scss" scoped>
.delivery-bill-container {
  .tb-header {
    -webkit-print-color-adjust: exact;
    display: flex !important;
    justify-content: space-between !important;
    flex-wrap: no-wrap !important;
    background-color: #000 !important;
    color: #fff !important;
    height: 50px !important;
    align-items: center !important;
  }
  padding: 10% !important;
  .header {
    margin-left: 85% !important;
  }
  .containing-img {
    margin-top: 25px !important;
    .left-img {
      display: inline-block !important;
      width: 80% !important;
    }
    .righ-of-img {
      display: inline-block !important;
      width: 20% !important;
    }
  }
}
</style>